/** Display a normalized AI score as a whole number from 0 to 100, never a percentage. */
export const formatAiScore = (score: number | null | undefined): string =>
    score == null || !Number.isFinite(score) ? '-' : String(Math.round(Math.max(0, Math.min(1, score)) * 100));
